import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { OrientationType, ScreenOrientation } from '@capawesome/capacitor-screen-orientation';
import { storagePrefixFixedV2 } from '@/constant';
import cx from './index.module.scss';

const FULL_TIPS_IMG = storagePrefixFixedV2 + '/image/full-tips-new.png';
interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  tipText?: string;
  onClickOK?: VoidFunc;
}

const ScreenFlipTip: React.FC<Props> = ({ open, setOpen, tipText, onClickOK }) => {
  const [controlDomShow, setControlDomShow] = useState(open);

  useEffect(() => {
    let timer = null;
    if (open) {
      setControlDomShow(true);
    } else {
      timer = setTimeout(() => setControlDomShow(false), 500);
    }
    return () => {
      clearTimeout(timer);
      timer = null;
    };
  }, [open]);

  return ReactDOM.createPortal(
    <>
      <div className={cx('screen-flip-tip', { open, show: controlDomShow })}>
        <div className={cx('mask')} />
        <div className={cx('content')}>
          <div className={cx('modal-box')}>
            <div className={cx('title')}>
              <div>{tipText || '为了您更好的体验AI问诊功能，请将屏幕进行旋转'}</div>
              <div
                className={cx('close-text')}
                onClick={() => {
                  if (onClickOK) {
                    onClickOK?.();
                  } else {
                    setOpen(false);
                    setTimeout(() => ScreenOrientation.lock({ type: OrientationType.LANDSCAPE_PRIMARY }), 500);
                  }
                }}
              >
                完成
              </div>
            </div>
            <div className={cx('img-box')}>
              <img src={FULL_TIPS_IMG} alt="" />
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default ScreenFlipTip;
